/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApplicationMetadataDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const applicationMetadataGetApplicationMetadata = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ApplicationMetadataDTO>(
      {url: `/api/application-metadata`, method: 'GET', signal
    },
      );
    }
  

export const getApplicationMetadataGetApplicationMetadataQueryKey = () => {
    return [`/api/application-metadata`] as const;
    }

    
export const getApplicationMetadataGetApplicationMetadataQueryOptions = <TData = Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApplicationMetadataGetApplicationMetadataQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>> = ({ signal }) => applicationMetadataGetApplicationMetadata(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApplicationMetadataGetApplicationMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>>
export type ApplicationMetadataGetApplicationMetadataQueryError = ErrorType<unknown>


export function useApplicationMetadataGetApplicationMetadata<TData = Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>,
          TError,
          Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApplicationMetadataGetApplicationMetadata<TData = Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>,
          TError,
          Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApplicationMetadataGetApplicationMetadata<TData = Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApplicationMetadataGetApplicationMetadata<TData = Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof applicationMetadataGetApplicationMetadata>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApplicationMetadataGetApplicationMetadataQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



